import React, { Component } from "react";
import AntdIcon, { IconProps } from "antd/lib/icon";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/icon/style";

const { createFromIconfontCN, getTwoToneColor, setTwoToneColor } = AntdIcon;

interface IProps extends IconProps {
  [propName: string]: any;
}
export default class Icon extends Component<IProps> {
  static createFromIconfontCN = createFromIconfontCN;
  static getTwoToneColor = getTwoToneColor;
  static setTwoToneColor = setTwoToneColor;
  render() {
    return (
      <ConfigConsumer>
        {({ pagePoint }: ConfigConsumerEProps) =>
          pagePoint ? (
            <PagePoint
              compType="Icon"
              {...this.props}
              render={eventprops => (
                <AntdIcon {...this.props} {...eventprops} />
              )}
            ></PagePoint>
          ) : (
            <AntdIcon {...this.props} />
          )
        }
      </ConfigConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/icon/index.tsx